/* Quantity controls enhance a normal Shopify cart POST form. */
(() => {
  if (window.howCartControls) return;
  window.howCartControls = true;
  function initialize(scope) {
    scope.querySelectorAll('[data-how-cart]').forEach(form => {
      if (form.dataset.howInitialized) return;
      form.dataset.howInitialized = 'true';
      const inputs = [...form.querySelectorAll('input[name="updates[]"]')];
      const note = form.querySelector('textarea[name="note"]');
      const initialNote = note?.value || '';
      function updateState() {
        let dirty = Boolean(note && note.value !== initialNote);
        inputs.forEach(input => {
          const value = Number(input.value), minimum = Number(input.dataset.min || 1), step = Number(input.dataset.increment || 1);
          const invalid = input.value !== '' && value > 0 && (value < minimum || (value - minimum) % step !== 0);
          input.setCustomValidity(invalid ? input.dataset.quantityError : '');
          dirty ||= input.value !== input.dataset.initialValue;
          const control = input.closest('[data-how-quantity]');
          control.querySelector('[data-how-quantity-minus]').disabled = input.readOnly || value <= Number(input.min || 0);
          control.querySelector('[data-how-quantity-plus]').disabled = input.readOnly || (input.max !== '' && value >= Number(input.max));
        });
        form.querySelector('[data-how-cart-notice]').hidden = !dirty;
        // Accelerated buttons operate on the server cart, so require an update first.
        const accelerated = form.querySelector('[data-how-accelerated]');
        if (accelerated) accelerated.hidden = dirty;
      }
      form.addEventListener('click',event => {
        const button = event.target.closest('[data-how-quantity-minus],[data-how-quantity-plus]');
        if (!button || button.disabled) return;
        const input = button.closest('[data-how-quantity]').querySelector('input');
        const step = Number(input.dataset.increment || 1), minimum = Number(input.dataset.min || 1), floor = Number(input.min || 0);
        let value = Number(input.value) || 0;
        if (button.hasAttribute('data-how-quantity-minus')) value = value <= minimum ? floor : value - step;
        else value = value === 0 ? minimum : value + step;
        value = Math.max(floor,value);
        if (input.max !== '') value = Math.min(Number(input.max),value);
        input.value = String(value);
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
      form.addEventListener('input',updateState);
      form.addEventListener('submit',event => {
        updateState();
        if (!form.reportValidity()) event.preventDefault();
      });
      updateState();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(document),{once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
